/* HUB19 1.0.0 — progressive enhancement; all prices and availability come from Shopify. */
(() => {
  'use strict';
  const configNode = document.getElementById('HubConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const strings = config.strings || {};
  const root = (config.root || '/').replace(/\/?$/, '/');
  const escapeCSS = value => CSS.escape(String(value));
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let toastTimer;
  function announce(message) {
    const live = $('#HubLive');
    if (live) { live.textContent = ''; requestAnimationFrame(() => { live.textContent = message; }); }
  }
  function toast(message) {
    const node = $('#HubToast');
    if (!node) return announce(message);
    clearTimeout(toastTimer); node.textContent = message; node.hidden = false;
    toastTimer = setTimeout(() => { node.hidden = true; }, 4500);
  }
  function errorAt(node, message) {
    if (!node) return toast(message);
    node.textContent = message; node.hidden = false;
  }
  const safeStorage = {
    get(store, key) { try { const list = JSON.parse(window[store].getItem(key) || '[]'); return Array.isArray(list) ? list.filter(x => typeof x === 'string' && /^[a-zA-Z0-9_-]+$/.test(x)) : []; } catch { return []; } },
    set(store, key, value) { try { window[store].setItem(key, JSON.stringify(value)); return true; } catch { return false; } }
  };
  async function htmlRequest(url, signal) {
    const response = await fetch(url, { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(strings.error);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async function jsonRequest(url, options = {}) {
    let response;
    try { response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...(options.headers || {}) } }); }
    catch { throw new Error(strings.refreshError || strings.error); }
    let data;
    try { data = await response.json(); } catch { throw new Error(strings.refreshError || strings.error); }
    if (!response.ok || (data.status && data.status >= 400)) {
      const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : strings.error;
      throw new Error(message);
    }
    return data;
  }
  const opener = new WeakMap();
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return;
    $$('dialog[open]').forEach(d => { if (d !== dialog) d.close(); });
    opener.set(dialog, trigger || document.activeElement);
    if (!dialog.open) dialog.showModal();
    if (id === 'WishlistDialog') renderWishlists();
  }
  function closeDialog(dialog) {
    if (dialog instanceof HTMLDialogElement) dialog.close();
  }
  document.addEventListener('close', e => {
    const trigger = opener.get(e.target);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }, true);
  document.addEventListener('click', e => {
    const opening = e.target.closest('[data-open-dialog]');
    if (opening) { e.preventDefault(); openDialog(opening.dataset.openDialog, opening); }
    const switching = e.target.closest('[data-switch-dialog]');
    if (switching) { closeDialog(switching.closest('dialog')); openDialog(switching.dataset.switchDialog, $('[data-open-dialog="MobileMenu"]')); }
    const closing = e.target.closest('[data-close-dialog]');
    if (closing) closeDialog(closing.closest('dialog'));
    if (e.target instanceof HTMLDialogElement) {
      const rect = e.target.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) closeDialog(e.target);
    }
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && config.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openDialog('CartDrawer', cartLink); }
    if (!e.target.closest('.nav-item')) $$('.nav-item[open]').forEach(d => d.open = false);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') $$('.nav-item[open]').forEach(d => { d.open = false; $('summary', d)?.focus(); });
  });
  document.addEventListener('toggle', e => {
    if (e.target.matches?.('.nav-item[open]')) $$('.nav-item[open]').forEach(d => { if (d !== e.target) d.open = false; });
  }, true);

  // Section-rendered, keyboard accessible predictive search. Normal GET search is the fallback.
  class HubSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.input = $('input[type="search"]', this); this.panel = $('.search-results', this); this.output = $('[data-search-output]', this);
      if (!this.input || this.dataset.predictive !== 'true') return;
      this.index = -1;
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.search(), 240); });
      this.input.addEventListener('focus', () => { if (this.input.value.trim().length > 1) this.search(); });
      this.input.addEventListener('keydown', e => this.keydown(e));
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.hide(); }, 0));
      this.addEventListener('submit', () => this.hide());
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
    hide() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); this.index = -1; }
    async search() {
      const query = this.input.value.trim(); this.controller?.abort();
      if (query.length < 2) return this.hide();
      this.controller = new AbortController();
      const url = new URL(config.predictiveUrl || root + 'search/suggest', location.origin);
      url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '5'); url.searchParams.set('section_id', 'predictive-search');
      try {
        const doc = await htmlRequest(url, this.controller.signal);
        if (this.input.value.trim() !== query) return;
        const content = $('[data-predictive-content]', doc);
        if (!content) throw new Error(strings.searchUnavailable);
        this.output.replaceChildren(...content.childNodes); this.panel.hidden = false; this.index = -1;
        this.input.setAttribute('aria-expanded', 'true');
        $('[data-search-status]', this).textContent = `${$$('[data-search-option]', this).length} suggestions`;
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.output.textContent = strings.searchUnavailable; this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true');
      }
    }
    keydown(e) {
      const options = $$('[data-search-option]', this);
      if (e.key === 'Escape') { this.hide(); return; }
      if (this.panel.hidden || !options.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); this.index = (this.index + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, i) => option.setAttribute('aria-selected', String(i === this.index)));
        this.input.setAttribute('aria-activedescendant', options[this.index].id); options[this.index].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.index >= 0) { e.preventDefault(); location.assign(options[this.index].href); }
    }
  }
  customElements.define('hub-search', HubSearch);

  // Mutations are serialized so cart keys and bundled-section totals never race one another.
  let cartQueue = Promise.resolve(); let cartPending = 0;
  function cartSectionIds() { return [...new Set($$('[data-cart-section]').map(n => n.dataset.cartSection))].slice(0, 5); }
  function cartBusy(busy) {
    $$('[data-cart-fragment]').forEach(n => { n.classList.toggle('cart-busy', busy); n.setAttribute('aria-busy', String(busy)); });
    $$('[data-checkout]').forEach(button => button.disabled = busy);
  }
  function serializeCart(task) {
    cartPending++; cartBusy(true);
    const promise = cartQueue.then(task);
    cartQueue = promise.catch(() => {}).finally(() => { cartPending--; if (!cartPending) cartBusy(false); });
    return promise;
  }
  function sectionPayload() { return { sections: cartSectionIds(), sections_url: location.pathname }; }
  async function refreshCartSections() {
    const ids = cartSectionIds();
    const url = new URL(location.pathname, location.origin); url.searchParams.set('sections', ids.join(','));
    const data = await jsonRequest(url);
    if (!renderCartSections(data)) throw new Error(strings.refreshError);
  }
  function renderCartSections(sections) {
    if (!sections || typeof sections !== 'object') return false;
    let updated = 0; let expected = cartSectionIds().length;
    const focus = document.activeElement; const focusId = focus?.id;
    const focusWasInCart = !!focus?.closest?.('[data-cart-fragment]');
    const openNotes = $$('.cart-note[open]').map(d => $('textarea', d)?.id);
    for (const html of Object.values(sections)) {
      if (typeof html !== 'string') continue;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-fragment]', doc);
      if (!fresh) continue;
      const current = $(`[data-cart-fragment="${fresh.dataset.cartFragment}"]`);
      if (!current) continue;
      const scrollable = $('.drawer-body', current); const scroll = scrollable?.scrollTop || 0;
      current.innerHTML = fresh.innerHTML; current.dataset.itemCount = fresh.dataset.itemCount; updated++;
      if ($('.drawer-body', current)) $('.drawer-body', current).scrollTop = scroll;
      const count = Number(fresh.dataset.itemCount || 0);
      $$('[data-cart-count]').forEach(badge => { badge.textContent = String(count); badge.hidden = count === 0; });
      init(current);
    }
    openNotes.forEach(id => { const field = id && document.getElementById(id); if (field) field.closest('details').open = true; });
    if (focusId && document.getElementById(focusId)) document.getElementById(focusId).focus({ preventScroll: true });
    if (focusWasInCart && !document.activeElement?.closest?.('[data-cart-fragment]')) {
      const fallback = $('dialog[open] [data-close-dialog]') || $('[data-cart-fragment="page"] a');
      fallback?.focus({ preventScroll: true });
    }
    if (cartPending) cartBusy(true);
    document.dispatchEvent(new CustomEvent('hub:cart:updated'));
    return updated >= expected && updated > 0;
  }
  async function finishMutation(data) {
    if (!renderCartSections(data.sections)) await refreshCartSections();
    return data;
  }
  async function mutateJSON(url, payload) {
    const data = await jsonRequest(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, ...sectionPayload() }) });
    return finishMutation(data);
  }
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    if (e.submitter && e.submitter.name !== 'add') return;
    e.preventDefault();
    if (form.dataset.pending === 'true' || !form.reportValidity()) return;
    form.dataset.pending = 'true';
    const button = $('[name="add"]', form); const label = button?.innerHTML; const error = $('[data-form-error]', form);
    if (error) error.hidden = true;
    const data = new FormData(form);
    // The no-JavaScript variant dropdown must not override the live hidden variant id.
    const variant = $('[data-variant-id]', form);
    if (variant) data.set('id', variant.value);
    data.delete('add');
    if (button) { button.disabled = true; button.textContent = strings.adding; }
    try {
      await serializeCart(async () => {
        data.set('sections', cartSectionIds().join(',')); data.set('sections_url', location.pathname);
        return finishMutation(await jsonRequest(config.addUrl, { method: 'POST', body: data }));
      });
      if (config.cartType === 'page') return location.assign(config.cartUrl);
      openDialog('CartDrawer', button); toast(strings.added);
    } catch (err) { errorAt(error?.isConnected ? error : $('[data-variant-error]'), err.message || strings.error); }
    finally { form.dataset.pending = 'false'; if (button?.isConnected) { button.disabled = false; button.innerHTML = label; } }
  });
  async function changeLine(key, quantity) {
    try {
      await serializeCart(() => mutateJSON(config.changeUrl, { id: key, quantity }));
    } catch (err) {
      const lines = $$(`[data-cart-line][data-line-key="${escapeCSS(key)}"]`);
      if (lines.length) lines.forEach(line => errorAt($('[data-line-error]', line), err.message || strings.error));
      else errorAt($('dialog[open] [data-cart-error]') || $('[data-cart-error]'), err.message || strings.error);
    }
  }
  document.addEventListener('click', e => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); if (!cartPending) changeLine(remove.dataset.lineKey, 0); }
    const stepper = e.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = $('input[type="number"]', stepper.closest('[data-quantity]'));
      if (!input || input.readOnly || stepper.disabled || (input.hasAttribute('data-cart-quantity') && cartPending)) return;
      const before = input.value;
      try { Number(stepper.dataset.quantityStep) > 0 ? input.stepUp() : input.stepDown(); } catch { return; }
      if (before !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', e => {
    const input = e.target;
    if (input.matches('[data-cart-quantity]')) {
      if (!input.reportValidity() || cartPending) return;
      const quantity = Number(input.value);
      if (Number.isInteger(quantity) && quantity >= 0) changeLine(input.dataset.lineKey, quantity);
    }
    if (input.matches('[data-auto-submit]')) input.form?.requestSubmit();
  });
  document.addEventListener('click', async e => {
    const button = e.target.closest('[data-save-note]');
    if (!button || cartPending) return;
    const details = button.closest('.cart-note'); const field = $('textarea', details); const id = field.id;
    button.disabled = true;
    try { await serializeCart(() => mutateJSON(config.updateUrl, { note: field.value })); const current = document.getElementById(id)?.closest('.cart-note'); if (current) { current.open = true; $('[data-note-status]', current).textContent = strings.noteSaved; } }
    catch (err) { errorAt($('[data-note-status]', details), err.message); }
    finally { if (button.isConnected) button.disabled = false; }
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-discount-form]')) return;
    e.preventDefault(); if (cartPending || !form.reportValidity()) return;
    const code = new FormData(form).get('discount').trim();
    const fragment = form.closest('[data-cart-fragment]').dataset.cartFragment;
    try {
      const result = await serializeCart(() => mutateJSON(config.updateUrl, { discount: code }));
      const current = $(`[data-cart-fragment="${fragment}"] [data-discount-status]`);
      const applicable = (result.discount_codes || []).some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      if (current) { current.textContent = applicable ? strings.discountApplied : strings.discountInvalid; current.classList.toggle('error', !applicable); }
    } catch (err) { errorAt($(`[data-cart-fragment="${fragment}"] [data-discount-status]`), err.message); }
  });
  // Prevent checkout during a pending cart mutation. Native form association includes unsaved notes.
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form.getAttribute('id') || '').startsWith('CartForm-') || e.submitter?.name !== 'checkout') return;
    if (cartPending) { e.preventDefault(); toast(strings.refreshError); }
  });

  // Product option combinations are resolved by Shopify, including catalogs with >250 variants.
  class HubProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.addEventListener('change', e => {
        if (e.target.matches('[data-option-value-id]')) this.selectOption(e.target);
        if (e.target.matches('[data-selling-plan]')) this.updateSellingPlan(e.target);
      });
      this.addEventListener('click', e => {
        const thumbnail = e.target.closest('[data-show-media]');
        if (thumbnail) this.showMedia(thumbnail.dataset.showMedia);
        const zoom = e.target.closest('[data-zoom]');
        if (zoom) {
          const dialog = $('dialog.zoom-dialog', this); const image = $('[data-zoom-image]', dialog);
          image.src = zoom.dataset.zoom; image.alt = zoom.dataset.zoomAlt || '';
          openDialog(dialog.id, zoom);
        }
        if (e.target.closest('[data-scroll-to-buy]')) {
          const target = $('[data-variant-picker]', this) || $('[data-main-product-form]', this);
          target?.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'center' });
          $('input:checked,button[name="add"]', target || this)?.focus({ preventScroll: true });
        }
      });
      this.observeBuy();
      if (config.recentlyViewed && this.dataset.productHandle) {
        const previous = safeStorage.get('sessionStorage', 'hub19-recent-v1');
        safeStorage.set('sessionStorage', 'hub19-recent-v1', [this.dataset.productHandle, ...previous.filter(h => h !== this.dataset.productHandle)].slice(0, 12));
      }
      this.initModels();
    }
    disconnectedCallback() { this.controller?.abort(); this.buyObserver?.disconnect(); }
    showMedia(id) {
      if (!id || !$(`[data-media="${escapeCSS(id)}"]`, this)) return;
      $$('[data-media]', this).forEach(item => {
        const active = item.dataset.media === String(id); item.hidden = !active;
        if (!active) { $$('video', item).forEach(v => v.pause()); $$('iframe', item).forEach(frame => { if (frame.src) { const src = frame.src; frame.src = ''; frame.src = src; } }); }
      });
      $$('[data-show-media]', this).forEach(button => button.setAttribute('aria-current', String(button.dataset.showMedia === String(id))));
    }
    observeBuy() {
      this.buyObserver?.disconnect(); const button = $('[data-main-add]', this); const bar = $('[data-mobile-product-bar]', this);
      if (!button || !bar) return;
      this.buyObserver = new IntersectionObserver(entries => {
        const entry = entries[0]; bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }); this.buyObserver.observe(button);
    }
    async selectOption(input) {
      const base = new URL(this.dataset.productUrl, location.origin);
      if (input.dataset.productUrl) {
        const linked = new URL(input.dataset.productUrl, location.origin);
        if (linked.pathname !== base.pathname) { location.assign(linked.href); return; }
      }
      const ids = $$('[data-option-value-id]:checked', this).map(radio => radio.dataset.optionValueId);
      const url = new URL(base); url.searchParams.set('option_values', ids.join(',')); url.searchParams.set('section_id', this.dataset.sectionId);
      this.controller?.abort(); this.controller = new AbortController();
      const controller = this.controller;
      this.setAttribute('aria-busy', 'true');
      const error = $('[data-variant-error]', this); error.hidden = true;
      const quantity = $('[name="quantity"]', this)?.value;
      const oldButtons = $$('[data-main-product-form] button, [data-main-product-form] input, [data-main-product-form] select', this).map(el => [el, el.disabled]);
      oldButtons.forEach(([el]) => el.disabled = true);
      try {
        const doc = await htmlRequest(url, controller.signal); const fresh = $('hub-product', doc);
        if (controller !== this.controller) return;
        if (!fresh) throw new Error(strings.error);
        const freshState = $('[data-product-state]', fresh);
        const state = JSON.parse(freshState.textContent);
        $$('[data-variant-refresh]', fresh).forEach(node => {
          const current = document.getElementById(node.id);
          if (current && this.contains(current)) current.replaceWith(node);
        });
        $('[data-product-state]', this).replaceWith(freshState);
        const qty = $('[name="quantity"]', this);
        if (qty && quantity) { const min = Number(qty.min || 1), step = Number(qty.step || 1), max = Number(qty.max || Infinity); const wanted = Math.max(min, Math.min(Number(quantity), max)); qty.value = String(min + Math.floor((wanted - min) / step) * step); }
        const selectedInput = document.getElementById(input.id); selectedInput?.focus({ preventScroll: true });
        const pageUrl = new URL(location.href);
        if (state.id) { pageUrl.searchParams.set('variant', state.id); pageUrl.searchParams.delete('option_values'); }
        else { pageUrl.searchParams.set('option_values', ids.join(',')); pageUrl.searchParams.delete('variant'); }
        pageUrl.searchParams.delete('selling_plan');
        history.replaceState({}, '', pageUrl);
        this.showMedia(state.mediaId); this.observeBuy(); init(this);
        window.Shopify?.PaymentButton?.init();
        document.dispatchEvent(new CustomEvent('hub:variant:changed', { detail: { variantId: state.id, sectionId: this.dataset.sectionId } }));
      } catch (err) {
        if (err.name !== 'AbortError') {
          errorAt(error, `${strings.error} Reloading the selected product options.`);
          // Full navigation is a safe, non-mutating recovery, never a guessed variant id.
          const recovery = new URL(base); recovery.searchParams.set('option_values', ids.join(',')); location.assign(recovery.href);
        }
      } finally {
        if (this.controller === controller && !controller.signal.aborted) this.removeAttribute('aria-busy');
        // Old purchase controls stay disabled until replaced; never submit a stale variant.
      }
    }
    updateSellingPlan(select) {
      const url = new URL(location.href); if (select.value) url.searchParams.set('selling_plan', select.value); else url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
    }
    initModels() {
      if (!$('model-viewer', this) || !window.Shopify?.loadFeatures) return;
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: error => {
        if (!error && window.Shopify.ModelViewerUI) $$('model-viewer', this).forEach(model => { if (!model.dataset.uiReady) { new window.Shopify.ModelViewerUI(model); model.dataset.uiReady = 'true'; } });
      } }]);
    }
  }
  customElements.define('hub-product', HubProduct);
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return; this.loaded = true;
      htmlRequest(this.dataset.url).then(doc => {
        const content = $('product-recommendations', doc);
        if (content && content.innerHTML.trim()) { this.innerHTML = content.innerHTML; this.hidden = false; init(this); }
      }).catch(() => { this.hidden = true; });
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  const wishKey = 'hub19-wishlist-v1'; const cardCache = new Map(); let wishVersion = 0;
  function syncWishlistButtons(scope = document) {
    const saved = safeStorage.get('localStorage', wishKey);
    $$('[data-wishlist]', scope).forEach(button => {
      const active = saved.includes(button.dataset.wishlist); button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? strings.removeWishlist : strings.saveWishlist);
      const label = $('[data-wishlist-label]', button); if (label) label.textContent = active ? strings.removeWishlist : strings.saveWishlist;
    });
  }
  async function fetchCard(handle, prefix) {
    if (!/^[a-zA-Z0-9_-]+$/.test(handle)) return null;
    if (!cardCache.has(handle)) {
      cardCache.set(handle, htmlRequest(root + 'products/' + encodeURIComponent(handle) + '?view=hub-card').then(doc => {
        const card = $('[data-product-card]', doc); if (!card) throw new Error('Product unavailable'); return card.outerHTML;
      }).catch(() => { cardCache.delete(handle); return null; }));
    }
    const html = await cardCache.get(handle); if (!html) return null;
    const template = document.createElement('template'); template.innerHTML = html;
    const card = template.content.firstElementChild;
    // Distinct ids for identical products across dialog, page and recently-viewed grids.
    $$('[id]', card).forEach(el => { const old = el.getAttribute('id'); const next = prefix + '-' + old; $$(`[for="${escapeCSS(old)}"]`, card).forEach(label => label.htmlFor = next); el.setAttribute('id', next); });
    return card;
  }
  async function renderWishlists() {
    const version = ++wishVersion; const saved = safeStorage.get('localStorage', wishKey).slice(0, 50);
    const containers = $$('[data-wishlist-container]');
    await Promise.all(containers.map(async (container, index) => {
      const grid = $('[data-wishlist-grid]', container); const empty = $('[data-wishlist-empty]', container);
      if (!grid) return; container.setAttribute('aria-busy', 'true');
      try {
        const cards = await Promise.all(saved.map(handle => fetchCard(handle, 'wish-' + index)));
        if (version !== wishVersion) return;
        grid.replaceChildren(...cards.filter(Boolean)); empty.hidden = cards.some(Boolean);
        if (saved.length && !cards.some(Boolean)) empty.textContent = 'Saved products could not be loaded. They may no longer be available.';
        syncWishlistButtons(container);
      } finally { if (version === wishVersion) container.removeAttribute('aria-busy'); }
    }));
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-wishlist]'); if (!button) return;
    const handle = button.dataset.wishlist; if (!/^[a-zA-Z0-9_-]+$/.test(handle)) return;
    const saved = safeStorage.get('localStorage', wishKey); const active = saved.includes(handle);
    if (!active && saved.length >= 50) { toast('Your wishlist is full. Remove a saved product to add another.'); return; }
    const next = active ? saved.filter(h => h !== handle) : [handle, ...saved];
    if (!safeStorage.set('localStorage', wishKey, next)) { toast('Browser storage is unavailable. Your wishlist could not be saved.'); return; }
    syncWishlistButtons(); toast(active ? strings.removed : strings.saved);
    if ($('#WishlistDialog')?.open || $('[data-wishlist-page]')) renderWishlists();
  });
  window.addEventListener('storage', e => { if (e.key === wishKey) { syncWishlistButtons(); if ($('#WishlistDialog')?.open || $('[data-wishlist-page]')) renderWishlists(); } });
  async function recentlyViewed(scope = document) {
    const sections = $$('[data-recently-viewed]', scope);
    await Promise.all(sections.map(async section => {
      if (section.dataset.initialized) return; section.dataset.initialized = 'true';
      const handles = safeStorage.get('sessionStorage', 'hub19-recent-v1').filter(h => h !== section.dataset.exclude).slice(0, Number(section.dataset.limit || 4));
      const cards = await Promise.all(handles.map(handle => fetchCard(handle, 'recent-' + (section.closest('[id]')?.id || 'grid'))));
      const valid = cards.filter(Boolean); if (!valid.length) return;
      $('[data-recent-grid]', section).replaceChildren(...valid); section.hidden = false; syncWishlistButtons(section);
    }));
  }
  document.addEventListener('click', async e => {
    if (e.target.closest('[data-share]')) {
      try {
        if (navigator.share) await navigator.share({ title: document.title, url: location.href });
        else { await navigator.clipboard.writeText(location.href); toast(strings.copied); }
      } catch (err) { if (err.name !== 'AbortError') toast('Copy the page address from your browser to share this product.'); }
    }
    const motion = e.target.closest('[data-motion-toggle]');
    if (motion) { const hero = motion.closest('[data-hero]'); const paused = hero.dataset.paused !== 'true'; hero.dataset.paused = String(paused); motion.setAttribute('aria-pressed', String(paused)); motion.textContent = paused ? 'Resume animation' : 'Pause animation'; }
    if (e.target.closest('[data-print]')) window.print();
  });
  function initAddressForm(form) {
    if (form.dataset.ready) return; form.dataset.ready = 'true';
    const country = $('[data-address-country]', form); const province = $('[data-address-province]', form); const wrapper = $('[data-province-wrap]', form);
    if (!country || !province) return;
    const defaultCountry = country.dataset.default;
    [...country.options].forEach(option => { if (option.value === defaultCountry || option.textContent === defaultCountry) option.selected = true; });
    const refresh = useDefault => {
      let provinces = []; try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { /* no provinces for this country */ }
      province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
      if (useDefault && province.dataset.default) province.value = province.dataset.default;
      if (wrapper) wrapper.hidden = provinces.length === 0; province.disabled = provinces.length === 0;
    };
    country.addEventListener('change', () => refresh(false)); refresh(true);
  }
  document.addEventListener('submit', e => { if (e.target.matches('[data-address-delete]') && !confirm(strings.confirmDelete)) e.preventDefault(); });
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } });
  }, { threshold: .06 }) : null;
  function init(scope = document) {
    $$('[data-sticky]', scope).forEach(header => header.closest('.header-section')?.classList.add('is-sticky'));
    syncWishlistButtons(scope); recentlyViewed(scope);
    $$('[data-address-form]', scope).forEach(initAddressForm);
    $$('.form-errors:not([hidden]), .success', scope).forEach(message => {
      const details = message.closest('details'); if (details && message.textContent.trim()) details.open = true;
    });
    if (config.reveal && !reducedMotion.matches && revealObserver && !window.Shopify?.designMode) {
      $$('.section-head', scope).forEach(node => { if (!node.dataset.revealReady) { node.dataset.revealReady = 'true'; node.classList.add('reveal'); revealObserver.observe(node); } });
    }
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => { const details = e.target.closest('details'); if (details) details.open = true; });
  document.addEventListener('visibilitychange', () => $$('[data-hero]').forEach(hero => hero.classList.toggle('motion-suspended', document.hidden)));
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCartSections().catch(() => {}); });
  init(); if ($('[data-wishlist-page]')) renderWishlists();
})();
